"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.createValidator = createValidator;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _formatErrorMessage = _interopRequireDefault(require("./formatErrorMessage"));

/**
 * Create a data validator
 * @param data
 */
function createValidator(data, name) {
  return function (value, rules) {
    for (var i = 0; i < rules.length; i += 1) {
      var _rules$i = rules[i],
          onValid = _rules$i.onValid,
          errorMessage = _rules$i.errorMessage,
          params = _rules$i.params;
      var checkResult = onValid(value, data, name);

      if (checkResult === false) {
        return {
          hasError: true,
          errorMessage: (0, _formatErrorMessage["default"])(errorMessage, (0, _extends2["default"])({}, params, {
            name: Array.isArray(name) ? name.join('.') : name
          }))
        };
      } else if (typeof checkResult === 'object' && (checkResult.hasError || checkResult.array)) {
        return checkResult;
      }
    }

    return null;
  };
}

var _default = createValidator;
exports["default"] = _default;